/**
 * @global $
 * @global Backbone
 * @global gettext
 * @global userPasswordResetUrl
 */
(function () {
  "use strict";

  var PasswordResetView = (window.PasswordResetView = Backbone.View.extend({
    el: "#form_reset_password",

    events: {
      submit: "submit",
    },

    initialize: function () {
      this.$success = this.$el.find(".success");
      this.$failure = this.$el.find(".failure");
      this.$loading = this.$el.find(".progress");

      $.getJSON(userPasswordResetUrl, function (response) {
        $("[name=csrfmiddlewaretoken]").val(response.token);
        $(".loading").removeClass("loading");
        $("#email").focus();
      });
    },

    submit: function (e) {
      e.preventDefault();

      this.$loading.show();
      this.$failure.hide();
      this.$success.hide();

      $.post(
        userPasswordResetUrl,
        this.$el.serialize(),
        function (response) {
          response = JSON.parse(response);
          this.$loading.hide();

          if (response.success) {
            this.$success.html(gettext("Email sent")).show();
            this.$el[0].reset();
          } else {
            this.$failure.html(response.error.description.join("<br/>")).show();
          }
        }.bind(this)
      ).fail(
        function (error) {
          if (error.status == 429) {
            var response = JSON.parse(error.responseText);
            this.$failure.html(response.error.description.join("<br/>")).show();
            return;
          }
          console.error("Unexpected error", error);
        }.bind(this)
      );
    },
  }));
})();
